import { render } from "./stand.vue?vue&type=template&id=ff01d60c"
import script from "./stand.vue?vue&type=script&lang=js"
export * from "./stand.vue?vue&type=script&lang=js"

import "./stand.vue?vue&type=style&index=0&id=ff01d60c&lang=less"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__